import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { BehaviorSubject } from "rxjs";
import { __values } from "tslib";

@Injectable()
export class JwtService {
  decodedToken: any
  private jwtHelper = new JwtHelperService()
  private currentUserRoles: any = new BehaviorSubject<string[]>([]);

  constructor() {
    //updated the currentUserRole when any feture component calls this service then it can use updated userRoles which are coming from token
    this.updateUserRolesFromToken(); // Initialize roles on service creation
  }

  decodeToken(token: any) {
    this.decodedToken = this.jwtHelper.decodeToken(token);
    return this.decodedToken;
  }

  /**
 * Updates currentUserRoles from the JWT token
 */
  updateUserRolesFromToken(): void {
    const token = localStorage.getItem('mbcrm/token');

    if (token) {
      try {
        const decodedToken = this.jwtHelper.decodeToken(token);
        const roles =
          decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

        // ✅ normalize roles (sometimes a single string, sometimes array)
        const normalizedRoles = Array.isArray(roles)
          ? roles
          : roles
            ? [roles]
            : [];

        this.currentUserRoles.next(normalizedRoles);
      } catch (e) {
        console.error('Error decoding token:', e);
        this.currentUserRoles.next([]);
      }
    } else {
      this.currentUserRoles.next([]);
    }
  }


  getUserPropertyValueFromToken(propertyURL: string) {
    const token = localStorage.getItem('mbcrm/token');
    const decodedToken = this.decodeToken(token || '');
    if (decodedToken) {
      return decodedToken[propertyURL] || '';
    }
    return '';
  }

  //get the updated & latest roles after extracting from token
  get currentUserRolesValue(): string[] {
    return this.currentUserRoles.getValue() || [];
  }

  //set the currentUserRoles as observable
  currentUserRole$() {
    return this.currentUserRoles.asObservable();
  }

  isCurrentUserInRole(roleName: string): boolean {
    const roles = this.currentUserRoles.getValue();
    var roleExists = roles.includes(roleName);
    return roleExists;
  }

  /**
 * Gets unique sites from user login response
 * @param userSites Total Sites records from which unique records have to be searched
 * @param uniqueFieldToSearch Unique field on basis of which field it has to be searched
 * @returns Returns array of Unique site records
 */
  getUniqueSitesFromToken(userSites: any, uniqueFieldToFind: any) {
    let UniqueSites: any[] = [];
    let isExists: boolean = false

    userSites.forEach((site: any) => {
      isExists = false;

      UniqueSites.forEach(currUniquesite => {
        if (site[uniqueFieldToFind] == currUniquesite[uniqueFieldToFind])
          isExists = true;
      })
      if (!isExists) UniqueSites.push(site)
    });

    return UniqueSites;
  }
}